import { render } from "./pos-qrcode.vue?vue&type=template&id=3e88e5f4"
import script from "./pos-qrcode.vue?vue&type=script&lang=js"
export * from "./pos-qrcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__